import * as React from 'react';
import Common from './Quote/Common';
import useReduxState from "../hooks/useReduxState";
import {useSearchParams} from "react-router-dom";

export function Quote() {
    const [searchParams] = useSearchParams();
    const [Quote__Component__Loader] = useReduxState(searchParams.get(Common.param_key) ? searchParams.get(Common.param_key) : Common.default_component.param_value, Common.redux_key);
    return (
        <>
            <div className="logged-screen">
                <div className="">
                    {React.createElement(Common.chain[Quote__Component__Loader].element)}
                </div>
            </div>
        </>
    );
}